import React from 'react';
import mailIcon from './mail.png';
import { Link, RouteComponentProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthStatusPage from 'components/auth/AuthStatusPage';
import { HyperLink } from 'styles/Styles.styled';

const ForgotPasswordSuccess: React.FC<RouteComponentProps> = () => {
  return (
    <AuthStatusPage
      imageSrc={mailIcon}
      imageAlt="Success"
      title="Email has been sent!"
      message="If your account is registered, you will receive an email with instructions to reset your password."
      link={
        <HyperLink as={Link} to={EpdRoutes.login}>
          Back to login page
        </HyperLink>
      }
    />
  );
};

export default ForgotPasswordSuccess;
